import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './mailheader.module.scss';
import TabButton from './../UiComponents/TabButton';
import getLabel from './../../utils/labels'
import mailIcon from './../../globals/images/mails_icon.svg';
import sentMailIcon from './../../globals/images/sent_mail_icon.svg';
import starredIcon from './../../globals/images/star_selected.png';
import attachementIcon from './../../globals/images/attachment.svg';

class MailHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: props.selectedTab,
            isStarred: false,
            isAttachment: false
        };
    }

    componentWillReceiveProps = (nextProps) => {
        let { selectedTab, match } = nextProps;
        this.setState({
            selectedTab: selectedTab,
            isStarred: match.url === "/mails/starred",
            isAttachment: match.url === "/mails/attachments",

        });
    }

    getFilterButtonUrl = (name) => {
        let { match } = this.props;
        if (match.url === `/mails/${name}`) {
            return "/mails"
        } else {
            return `/mails/${name}`
        }
    }

    render() {
        const { unreadMails, totalMails, currentMails, isMailThreadView, currentMailIndex } = this.props;
        const { selectedTab, isStarred, isAttachment } = this.state;
        return <div className={styles['container']}>
            <div className={styles.tabButtonContainer}>
                <TabButton
                    className={styles['all-mails']}
                    isSelected={1 === selectedTab}
                    key={1}
                    to="/mails"
                >
                    <img src={mailIcon} style={{ width: '20px', height: '20px' }} />
                    <p>{getLabel('label_mails')}</p>
                    {
                        unreadMails > 0 ?
                            <div className={styles.count}>{unreadMails}</div>
                            :
                            null
                    }
                </TabButton>
                <TabButton
                    className={styles['sent-mails']}
                    key={2}
                    isSelected={2 === selectedTab}
                    isEnabled
                    to="/mails/sent"
                >
                    <img src={sentMailIcon} style={{ width: '13px', height: '11px' }} />
                    <p>{getLabel('label_sent')}</p>
                </TabButton>
            </div>
            <div className={styles['filter']}>
                <div className={styles['filter-icons']} id="tutorial-filter" style={isMailThreadView ? { display: 'none' } : {}}>
                    <div style={{ marginRight: '10px' }}>{getLabel('label_filter_by')}</div>
                    <div className={styles.filterButton}>
                        <Link to={this.getFilterButtonUrl('starred')}><img src={starredIcon} className={styles.filterimg} /></Link>
                        {
                            isStarred ?
                                <div className={styles['show-selected-icon']} />
                                :
                                null
                        }
                    </div>
                    <div className={styles.filterButton}>
                        <Link to={this.getFilterButtonUrl('attachments')}><img src={attachementIcon} className={styles.filterimgattach} /></Link>
                        {
                            isAttachment ?
                                <div className={styles['show-selected-icon']} />
                                :
                                null
                        }
                    </div>
                </div>
                {
                    isMailThreadView ?
                        <div className={styles['mail-id']}>{("0" + (currentMailIndex + 1)).slice(-2)} {getLabel('label_of')}</div>
                        :
                        null
                }
                <div className={styles['mail-text']}>{("0" + currentMails).slice(-2)} {getLabel('label_mails_small')}</div>
            </div>
        </div>;
    }
}
MailHeader.propTypes = {

};

MailHeader.defaultProps = {

};

export default MailHeader;


// WEBPACK FOOTER //
// /src/components/mailHeader/MailHeader.js